module Meevo.Plugins.EftControlPanel {
    export enum EFTStatusEnum {
        Processing = 0,
        Refund = 20005,
        NotBilled = 30011,
        Paid = 30012,
        Error = 30013,
        Failed = 30014,
        Waived = 30015,
        Suspended = 30017,
        Pending = 30018,
        Deleted = 30019,
        FreezeFee = 30032,
        PIFFreezeFee = 30215
    }

    export enum EPaymentPlanBillStatusEnum {
        Paid = 11045282,
        Error = 11045283,
        PastDue = 11045284,
        Pending = 11045285,
        NotBilled = 11045315,
        Processing = 0,
    }
}
